export default function mobileCarousel() {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-mobile-carousel]').forEach((track) => {
    const cards = [...track.children];
    if (cards.length < 2) return;

    const pagination = document.createElement('div');
    pagination.className = 'carousel-pagination';
    pagination.setAttribute('role', 'group');

    const sectionTitle = track.closest('section')?.querySelector('h2[id]');
    if (sectionTitle) pagination.setAttribute('aria-labelledby', sectionTitle.id);

    const dots = cards.map((card, index) => {
      const dot = document.createElement('button');
      const labelElement = card.querySelector(track.dataset.carouselLabelSelector);

      dot.type = 'button';
      dot.className = 'carousel-pagination__dot';
      dot.setAttribute('aria-label', labelElement?.getAttribute('alt') || labelElement?.textContent.trim() || String(index + 1));
      dot.addEventListener('click', () => {
        setActive(index);
        track.scrollTo({
          left: cards[index].offsetLeft - cards[0].offsetLeft,
          behavior: reducedMotion.matches ? 'auto' : 'smooth',
        });
      });
      pagination.append(dot);
      return dot;
    });

    function setActive(index) {
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    let scrollFrame = 0;
    track.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(() => {
        scrollFrame = 0;
        const activeIndex = cards.reduce((closest, card, index) =>
          Math.abs(card.offsetLeft - cards[0].offsetLeft - track.scrollLeft) <
          Math.abs(cards[closest].offsetLeft - cards[0].offsetLeft - track.scrollLeft)
            ? index : closest, 0);
        setActive(activeIndex);
      });
    }, { passive: true });

    setActive(0);
    track.after(pagination);
  });
}
